import { reactive, toRefs } from "vue"

// Shared menu-search state. The topbar (App.vue) drives `searchOpen`/`searchText`,
// the menu (MenuPage.vue) reads `searchText` to filter the displayed products.
const state = reactive({
    searchOpen: false,
    searchText: ""
})

function open() {
    state.searchOpen = true
}

function close() {
    state.searchOpen = false
    state.searchText = ""
}

function toggle() {
    if (state.searchOpen) {
        close()
    } else {
        open()
    }
}

export default {
    ...toRefs(state),
    open,
    close,
    toggle
}
